import { Profession } from '@/enums/profession';
import type { TaskProfession } from '@/types/data';

export const midnightCooking: TaskProfession = {
    id: Profession.Cooking,
    subProfessionId: 2908,
};

export const dragonflightCooking: TaskProfession = {
    id: Profession.Cooking,
    subProfessionId: 2824,
};
